import axiosObj from "../../../../../store/axios"
export const API_BASE_URL = "https://nestingale.com";

export const fetchFavorites = async (customerId:string) => {
    let favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    if (customerId) {
        try {
            const response = await axiosObj.get(
                `${API_BASE_URL}/v1/api/customer-favorites?customerId=${customerId}`
            );
            const backendFavorites = response.data.map(
                (item: { itemId: string }) => item.itemId
            );
            favorites = [...favorites, ...backendFavorites];
        } catch (error) {
            console.error('Error fetching favorite status:', error);
        }
    }
    return favorites;
};

export const postFavorite = async (customerId:string, favoriteData:any) => {
    let response = {}
    try {
        response = await axiosObj({
            method: 'post',
            url: `${API_BASE_URL}/v1/api/customer-favorites`,
            data: favoriteData,
            headers: { 'Content-Type': 'application/json' },
        });
    } catch (error) {
        console.error('Error fetching favorite status:', error);
        return error;
    }
    return response;
};

export const deleteFavorite = async (customerId:string, favoriteData:any) => {
    let response = {}
    try {
        response = await axiosObj({
            method: 'delete',
            url: `${API_BASE_URL}/v1/api/customer-favorites`,
            data: favoriteData,
            headers: { 'Content-Type': 'application/json' },
        });
    } catch (error) {
        console.error('Error fetching favorite status:', error);
        return error;
    }
    return response;
};